import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import {
	CookieConsentAction,
	cookieConsentDeclined,
	CookieConsentSelector,
	DataProtectionConfigService,
} from "@obg/ngx.common";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { combineLatest, Subscription } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

export const COOKIE_SETTINGS_DIALOG_ID = "cookie-settings";

@Component({
	selector: "obg-m-cookie-settings-dialog-container",
	templateUrl: "./cookie-settings-dialog.container.html",
	styleUrls: ["./cookie-settings-dialog.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CookieSettingsDialogContainer implements OnInit, OnDestroy {
	// TODO [OneTrust]:
	// This file needs to be refactored once oneTrust is rolled out on all the brands: https://edgealpha.corpsson.com/browse/AOCC-3162
	@HostBinding("class.obg-m-cookie-settings-dialog") hostCssClass = true;
	@ViewChild("dialog", { static: true }) dialogLayout!: DialogLayoutComponent;

	private initCookieConsent$$: Subscription | undefined;

	constructor(
		private store: Store<CoreState>,
		private dataProtectionConfig: DataProtectionConfigService,
		private cookieConsentSelector: CookieConsentSelector,
		private cookieConsentAction: CookieConsentAction
	) {}

	ngOnInit() {
		if (this.dialogLayout.isDialog || this.dataProtectionConfig.getCookieConsentDisabled()) {
			return;
		}

		this.initCookieConsent$$ = combineLatest([
			this.store.select(this.cookieConsentSelector.isConsentGiven()),
			this.store.select(this.cookieConsentSelector.isAccepted()),
		])
			.pipe(
				filter(([isConsentGiven, isAccepted]) => !isConsentGiven && !isAccepted),
				take(1),
				tap(() => this.store.dispatch(this.cookieConsentAction.update(cookieConsentDeclined, false)))
			)
			.subscribe();
	}

	ngOnDestroy() {
		if (this.initCookieConsent$$) {
			this.initCookieConsent$$.unsubscribe();
		}
	}

	closePopup() {
		if (this.dialogLayout.isDialog && this.dialogLayout.close()) {
			return;
		}

		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
	}
}
